<dx-popup
    #writeOffInvoiceBox
    title="Confirmation"
    width="30%"
    height="35%"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="write-off-invoice-content">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <span class="confirm-msg">Are you sure you want to write off the invoice? Please supply a reason</span>
                <dx-form
                    #confirmForm
                    width="100%"
                    height="100%"
                    [colCount]="1"
                    [labelLocation]="defaultLabelLocation"
                    [(formData)]="invoiceWriteOffDetail"
                >
                    <dxi-item>
                        <dxo-label text="Amount"></dxo-label>
                        <div *dxTemplate>
                            <div class="transfer-amount">
                                <dx-number-box
                                    [width]="100"
                                    readOnly="true"
                                    [format]="currencyFormat"
                                    [(value)]="writeOffAmount"
                                ></dx-number-box>
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-area
                                [height]="80"
                                [maxLength]="170"
                                [(value)]="invoiceWriteOffDetail.writeOffDescription"
                            ></dx-text-area>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="closeIcon"
                                (onClick)="onHidden($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Write-Off"
                                useSubmitBehavior="true"
                                [icon]="saveIcon"
                                (onClick)="onWriteOffClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#writeOffInvoiceBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
